import { render, staticRenderFns } from "./jpb_12.vue?vue&type=template&id=59a763df&"
import script from "./jpb_12.vue?vue&type=script&lang=js&"
export * from "./jpb_12.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports